import { Component } from 'react'
import { withRouter } from 'react-router'

/**
 * ScrollToTop
 *
 * @class ScrollToTop
 * @type {any}
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
class ScrollToTop extends Component {
  /**
   * Component did update
   *
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  /**
   * Render
   */
  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/containers/ScrollToTop.jsx